import { REPORT_TYPE_IDS } from "../../../store/constants";
import AnnualDataQuality from "./AnnualDataQuality";

const AnnualSlaWaitingCompliance = () => (
  <AnnualDataQuality
    reportTypeId={REPORT_TYPE_IDS.annual_service_level_waiting_time_compliance}
    title="Annual Service-Level and Waiting-Time Compliance"
    description="Annual SLA and waiting-time compliance view with breach, percentile, and confidence warnings."
    emptyDataMessage="Annual SLA Compliance data is empty for the selected year."
    searchPrompt="Update filters and hit Search to retrieve annual SLA Compliance data."
  />
);

export default AnnualSlaWaitingCompliance;
